import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/global.css';
import { App } from '@/app';
import { FullPageError } from '@/components/full-page-error';
import { initOpenObserveRum } from '@/lib/openobserve-rum';
import { initSentry, Sentry } from '@/lib/sentry';
import { initTracing } from '@/lib/tracing';

const isSubmitterPage = /^\/org\/[^/]+/.test(window.location.pathname);

if (!isSubmitterPage) {
  initTracing();
  initOpenObserveRum();
}
initSentry();

// biome-ignore lint/style/noNonNullAssertion: standard React mount
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<FullPageError />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
